// Flag per il lancio iniziale del sito: le funzioni "social" (Community didattica,
// Messaggi tra docenti) sono complete a livello di codice ma vengono nascoste dal
// prodotto live per lanciare con un set di funzioni più piccolo e solido. Il codice
// non va toccato/rimosso: basta rimettere questo flag a true per riattivarle.
export const SOCIAL_FEATURES_ENABLED = false;
